<template>
	<div id="home" class="home">
		<div id="home1" class="centered">
      <!-- <img class="homeImg2 animate__animated animate__backInRight" alt="Vue logo" src="../assets/newworkdesk.png" > -->
      <img class="homeImg animate__animated animate__backInRight" alt="Vue logo" src="../assets/Home.png" >
      <h1 class="animate__animated animate__backInLeft mt-5">YOU CAME TO THE RIGHT PLACE</h1>
      <p class="animate__animated animate__backInRight mt-8">
      Provider of proven business solutions. <br>
      Understanding the challenges of business establishments today and anticipating the troubles <br> you will be facing tomorrow, underscores our strong commitment to innovation.
      </p>
      <!-- <v-btn elevation="2" large raised rounded x-small color="#365136" href="https://wd-csi.circuitsolutions-gis.com/" target="_blank" class="white--text">TRY OUR DEMO</v-btn> -->
		</div>

		<div id="features" class="" style="background-color: #f5f5f5;">
		<div class="featureContent ">
			<img class="hrisImg " data-aos="fade-left"
		data-aos-offset="300"
		data-aos-easing="ease-in-sine" alt="Vue logo" src="../assets/HRIS_1.png">
		
		<div data-aos="fade-right"
		data-aos-offset="300"
		data-aos-duration="800"><p class="pHRIS " >
			Human Resource Information System (HRIS) is software that provides a centralized repository of employee master data that the human resource management (HRM) group needs for completing core human resource (core HR) processes.
				<br>
				
				<v-btn  @click="show = !show" rounded color="#365136"  class="white--text ">Read More    <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon></v-btn>
			</p> </div>
		</div>
		
		<div class="readmoreHRIS" style="background-color: #ffffff">
			<template>
			<v-expand-transition>
				<div v-show="show">
				<v-divider></v-divider>
		
				<v-card-text>
			
				<h2 class="readHRIS text-center font-weight-bold"> KEY FEATURES </h2>
				
					<p  class="animate-on-scroll animate__animated animate__backInLeft"> <b> Graphical Representation of Employees via Department</b></p>
					<div class="graph"><br>
					<p class="pGraph animate-on-scroll animate__animated animate__backInLeft"> Employees are individuals engaged by an organization or company to fulfill specific roles in exchange for compensation. They operate under the guidance of employers and are subject to company policies. Employees can be classified into various categories based on their employment status, including full-time, part-time, regular, contract, seasonal, and temporary. This classification system helps delineate the different types of work arrangements within the workforce. Understanding these distinctions is crucial for effective human resource management and organizational planning
					
					</p>
					<img  class="graphImg animate-on-scroll animate__animated animate__backInRight" alt="Vue logo" src="../assets/graphEmp.png">
				
				</div>
			
			
			<div class="graph"><br> <br>
			<img  class="empImgs animate-on-scroll animate__animated animate__backInLeft " alt="Vue logo" src="../assets/empinfo.png">
			<p class="pEmp animate-on-scroll animate__animated animate__backInRight"> <b> Employee Information </b> <br> <br> Employee information refers to the data and details maintained by an organization regarding its workforce. This information typically includes personal details such as name, address, contact information, date of birth, social security number (or equivalent), and emergency contact information. Additionally, it may encompass employment-related data such as job title, department, salary or wage, work schedule, performance evaluations, training records, benefits enrollment, and any other relevant details pertaining to an individual's employment within the organization.  </p>
			</div>

			<p class="animate-on-scroll animate__animated animate__backInLeft"> <b> Leave Applications </b></p>
			<div class="graph"><br>
			<p class="pGraph animate-on-scroll animate__animated animate__backInLeft"> The Leave Application module allows HR to add and record leave entitlements or balances for employees in the system. This feature ensures that each employee’s available leave is updated and accurately maintained, providing a clear reference for payroll processing, timekeeping, and compliance with company leave policies.
			</p >
			<img  class="graphImg animate-on-scroll animate__animated animate__backInRight" alt="Vue logo" src="../assets/leaveapp.png">
			
			</div>

			
			<div class="graph"><br>
				<img  class="graphImg animate-on-scroll animate__animated animate__backInLeft" alt="Vue logo" src="../assets/appMan.png">
			<p class="pEmp animate-on-scroll animate__animated animate__backInRight"> <b> Applicant Information </b> <br> <br> The Applicant Information module allows HR to add, store, and manage information about job applicants. This feature enables you to maintain a detailed record of each applicant’s personal data, qualifications, and application status. When an applicant is selected for hire, their information can be seamlessly processed within the module to complete the hiring procedure efficiently.
			</p>
			</div>
			</v-card-text>
		</div>
		</v-expand-transition>
		</template>
		</div>  
		

		<div class="featureContent ">
			
			<p class="pHRIS " data-aos="fade-left"
		data-aos-offset="300"
		data-aos-easing="ease-in-sine">
			Timekeeping stores the records of each employee's time and track in the company wether it is a leave, overtime, or time records. It also provides records of reports for each module.    <br>
			
			<v-btn  @click="showTimekeeping = !showTimekeeping" rounded color="#365136" class="white--text">Read More  <v-icon>{{ showTimekeeping ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon></v-btn>
			</p>
			<img data-aos="fade-right"
		data-aos-offset="300"
		data-aos-easing="ease-in-sine" class="tkImg " alt="Vue logo" src="../assets/TK_1.png">
		</div>

		<div class="readmoreHRIS" style="background-color: #ffffff">
			<template>
			<v-expand-transition>
				<div v-show="showTimekeeping">
				<v-divider></v-divider>
		
				<v-card-text>
			
				<h2 class="readHRIS text-center font-weight-bold"> KEY FEATURES </h2>
				
					<p class="animate-on-scroll animate__animated animate__backInRight"> <b> Employee Reports </b></p>
					<div class="graph"><br>
					<p class="pGraph animate-on-scroll animate__animated animate__backInRight"> Employee reports are comprehensive documents that provide detailed insights into various aspects of an organization's workforce. These reports cover attendance, performance, training, compensation, satisfaction, turnover, diversity, and inclusion. They serve as essential tools for management decision-making, offering valuable data to analyze trends, evaluate performance, plan workforce strategies, and ensure compliance with legal and regulatory requirements.
					</p>
					<img  class="graphImg animate-on-scroll animate__animated animate__backInLeft" alt="Vue logo" src="../assets/empRep.png">
				
				</div>
			
			
			<div class="graph"><br> <br>
			<img  class="empImg animate-on-scroll animate__animated animate__backInRight" alt="Vue logo" src="../assets/approvals.png">
			<p class="pEmp animate-on-scroll animate__animated animate__backInLeft"> <b> Approvals </b> <br> <br> Approvals refer to the process by which supervisors or managers review and authorize employees' recorded work hours before they are finalized for payroll processing. In this process, supervisors typically verify the accuracy of employees' time entries, ensuring that they reflect the actual hours worked, breaks taken, and any exceptions such as overtime or leave. Once approved, these time records are considered valid for payroll calculation and subsequent payment to employees.  </p>
			
			</div>

			<p class="animate-on-scroll animate__animated animate__backInLeft"> <b> Documented Reports </b></p>
			<div class="graph"><br>
			<p class="pGraph animate-on-scroll animate__animated animate__backInLeft"> Documented employee reports refer to written or digital records that provide detailed information about various aspects of an organization's workforce. These reports encompass data and analysis related to attendance, performance, training, compensation, satisfaction, turnover, diversity, and inclusion. They serve as valuable tools for management decision-making, offering insights into trends, performance evaluations, workforce planning, and compliance with legal and regulatory requirements. Documented employee reports play a crucial role in facilitating effective human resource management and supporting organizational goals and objectives.   </p >
			<img  class="graphImg animate-on-scroll animate__animated animate__backInRight" alt="Vue logo" src="../assets/docrep.png">
			
			</div>

			
			<div class="graph"><br>
				<img  class="graphImg animate-on-scroll animate__animated animate__backInLeft" alt="Vue logo" src="../assets/bio.png">
			<p class="pEmp animate-on-scroll animate__animated animate__backInRight"> <b> Biometrics </b> <br> <br> Importing employee biometrics refers to the process of transferring or integrating biometric data of employees into a centralized system or database for identification and authentication purposes.</p>
			</div>
			</v-card-text>
		</div>
		</v-expand-transition>
		</template>
		</div>  





		<div class="featureContent ">
			<img data-aos="fade-left"
		data-aos-offset="300"
		data-aos-easing="ease-in-sine" class="hrisImg " alt="Vue logo" src="../assets/PAYROLL_1.png">
			<p data-aos="fade-right"
		data-aos-offset="300"
		data-aos-easing="ease-in-sine" class="pHRIS ">
			A Payroll Report is a document that employers use to verify their tax liabilities or cross-check financial data. It may include such information as pay rates, hours worked, overtime accrued, taxes withheld from wages, employer tax contributions, holiday balances and more.   <br>
			<v-btn  @click="showPayroll = !showPayroll" rounded color="#365136" class="white--text">Read More  <v-icon>{{ showPayroll ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon></v-btn>
			</p> 
		</div>
		
		<div class="readmoreHRIS" style="background-color: #ffffff">
			<template>
			<v-expand-transition>
				<div v-show="showPayroll">
				<v-divider></v-divider>
		
				<v-card-text>
			
				<h2 class="readHRIS text-center font-weight-bold"> KEY FEATURES </h2>
				
					<p class="animate__animated animate__backInLeft"> <b> Reports </b></p>
					<div class="graph"><br>
					<p class="pGraph animate__animated animate__backInLeft"> Employee payroll reports are comprehensive documents that provide detailed information about compensation and financial transactions related to employees' work. These reports typically include details such as gross wages, deductions, taxes withheld, net pay, and any additional earnings or adjustments. They may also encompass information about benefits, reimbursements, and other payroll-related expenses.
					</p>
					<img  class="graphImg animate__animated animate__backInLeft" alt="Vue logo" src="../assets/reports.png">
				
				</div>
			
			
			<div class="graph"><br> <br>
			<img  class="empImg animate__animated animate__backInLeft" alt="Vue logo" src="../assets/payrates.png">
			<p class="pEmp animate__animated animate__backInLeft"> <b> Payroll Rates </b> <br> <br> Payroll rates refer to the predetermined amounts of compensation that employees receive for their work within a specified period, typically on an hourly, daily, weekly, bi-weekly, or monthly basis. These rates may vary depending on factors such as the employee's position, level of experience, geographic location, and any applicable industry standards or regulations. Payroll rates encompass not only base wages but also additional compensation elements such as overtime pay, shift differentials, bonuses, commissions, and allowances. They are crucial for calculating employees' earnings accurately and ensuring compliance with labor laws and company policies. </p>
			</div>

			<p class="animate__animated animate__backInLeft"> <b> Configurations </b></p>
			<div class="graph"><br>
			<p class="pGraph animate__animated animate__backInLeft"> Payroll configurations encompass the settings and parameters established within a payroll system to manage various aspects of employee compensation and related processes. These configurations typically include defining pay structures, tax withholdings, deductions, benefits, and other financial elements. Additionally, payroll configurations may involve setting up rules for overtime calculations, leave accruals, and compliance with legal requirements such as minimum wage laws and tax regulations. Customizing payroll configurations allows organizations to tailor their payroll processes to meet their specific needs and ensure accuracy and compliance in managing employee compensation.      </p >
			<img  class="graphImg animate__animated animate__backInLeft" alt="Vue logo" src="../assets/config.png">
			
			</div>

			
			<div class="graph"><br>
				<img  class="graphImg animate__animated animate__backInLeft" alt="Vue logo" src="../assets/paydash.png">
			<p class="pEmp animate__animated animate__backInLeft"> <b> Payroll Dashboard </b> <br> <br> Payroll Dashboard is a visual representation or interface within a payroll management system that provides a summary of key payroll-related metrics and data in a user-friendly format. It offers at-a-glance insights into various aspects of payroll processing, such as total payroll expenses, employee salaries, taxes withheld, deductions, and net pay. Additionally, a payroll dashboard may include interactive features and customizable options, allowing users to drill down into specific details, generate reports, and track trends over time. The purpose of a payroll dashboard is to facilitate efficient payroll management, decision-making, and analysis by providing real-time access to critical payroll information in a centralized location.   </p>
			</div>
			</v-card-text>
		</div>
		</v-expand-transition>
		</template>
		</div>  

		</div>


		<div id="whyus" >
			<div class="whyus">
				<div class="workdeskP">
				
					<p class="" data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1500" style="text-align: center; font-size: 25px; padding-top: 10%;"><b>Elevate your workspace with </b> </p>
					<h1 data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine " class="d-flex  justify-center "> <img class=" " style="margin-right:20px" alt="workdesk logo" width="50px" height="50px" src="../assets/workdeskLogo.png">  WORKDESK  </h1>
			
					<p class="gateway" style="text-align: center; margin-top: 5%;  "> Your gateway to seamless workforce management. An Integrated Personnel Management System that combines HRIS, Timekeeping, Payroll functionalities, streamlining your day-to-day operations. Effortlessly manage your company's time, handle payroll tasks, and access comprehensive HR information, all in one centralized platform. 
					</p>	
				</div>
				<div class="workdeskOffers" style="margin-top: 5%;" data-aos="fade-up" data-aos-duration="1000">
				<template>
					<v-sheet max-width="100%" max-height="100%">
						<v-slide-group v-model="centerIndex" selected-class="bg-primary" show-arrows>
              <v-slide-group-item	v-for="(item, index) in items" :key="index">
                <v-card class="carousel-item">
                <v-img :src="item.image"></v-img>
                  <div class="mt-3">
                    <p class="carouselTitle">{{ item.title }}</p>
                  </div>
                </v-card>
              </v-slide-group-item>
						</v-slide-group>
					</v-sheet>
				</template>
				</div>
			</div>
		</div>
	
		<div id="packages" style="align-items: center; background-color: white; ">
	
			<div class="packHead" style="display: flex; padding-top: 2%; padding-bottom: 2%; margin-bottom: 5%; background-color: #f5f5f5; height: fit-content;  ">
			<div class="packPhrases" style="font-weight: bold;margin-left: 5%; color: #1c2120; text-align: center; margin-top: 5%; font-family: 'Poppins', sans-serif;"> EMPOWER YOUR BUSINESS WITH WORKDESK FLEXIBLE PACKAGES </div>
			<img class="packMan" style="margin-right: 5%;" alt="workdesk logo" width="200" height="200" src="../assets/packMan.png">

			</div>

		
			<div class="pack d-flex align-center justify-center ">
				<div class="flip-container" style="margin-right: 5%;">
					<div class="flipper">
					<div class="front">
						<img class="cloud" alt="workdesk logo" width="300" height="300" src="../assets/cloud2.png">
					</div>
					<div class="back">
						<div class="description font-weight-bold text-justify">Cloud-based Integrated Personnel Management Systems (IPMS) securely manage employee data and functionalities, providing robust security measures, role-based access control, and features like time tracking, payroll processing, recruitment, and compliance management. These systems integrate with other business systems, reducing IT overhead and offering scalability and accessibility.</div>
					</div>
					</div>
				</div>
				<div class="flip-container">
					<div class="flipper">
					<div class="front">
						<img class="cloud" alt="workdesk logo" width="300" height="300" src="../assets/cloud1.png">
					</div>
					<div class="back">
						<div class="description font-weight-bold text-justify">An on-premise Integrated Personnel Management System (IPMS) is hosted on an organization's premises, providing functions like employee information management, time tracking, payroll processing, recruitment, and compliance management. However, it may require higher upfront costs and ongoing maintenance compared to cloud-based solutions, and may be limited by the organization's IT resources and infrastructure capabilities.</div>
					</div>
					</div>
				</div>
			</div>
		</div>

		<div id="contactUs" style="padding-top: 10%; background-color: #365136; padding-bottom: 10%; display: flex;">
			<div class="sendEmail">
			<h1 class="centered white--text">  Send us an Email  <br> <img  class="sendEmailImg" style=" "  alt="Vue logo" src="../assets/sendemail2.gif"> </h1>
			</div>
		
			<div class="contact">
        <template>
          <v-container class="card">
          <v-card class="contact-card centered" elevation="3" data-aos="fade-left" data-aos-duration="1000">
            <v-card-text>
            <v-form @submit.prevent="submitForm">
              <v-text-field  label="Name" required outlined rounded dense></v-text-field>
              <v-text-field  label="Email" required outlined rounded dense type="email"></v-text-field>
              <v-textarea  label="Message" required outlined rounded dense></v-textarea>
              <v-btn color="#365136" type="submit" class="submit-button white--text" rounded>
              Send Email
              </v-btn>
            </v-form>
            </v-card-text>
          </v-card>
          </v-container>
        </template>
			</div>
		</div>
    <div id="supportApp">
      <div class="support-app">
        <img src="../assets/downloadapp.png" alt="Logo Download" class="app-icons">
        <h1 class="download-title">Download CSI WorkDesk</h1>
        <p>Time in and out on the go</p>
        <span class="app-sub-title">
          Time in and out offsite with GPS tracking, and view your attendance records right from your phone or tablet.
        </span>
        <div class="mt-6">
          <a href="https://apps.apple.com/ph/app/csi-workdesk/id6746436641" target="_blank">
            <img src="../assets/downloadtoappstore.png" alt="Download on the App Store" class="app-badge">
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.workdesk.myapp" target="_blank">
            <img src="../assets/downloadtoplaystore_resized.png" alt="Download on the Play Store" class="app-badge">
          </a>
        </div>
      </div>
    </div>
		<FooterPage/>
	</div>
</template>


<script>
import { SlideGroupItem } from 'vuetify';
import FooterPage from '@/components/FooterPage.vue';

export default {
  name: 'HomeView',
  components: {
    'v-slide-group-item': SlideGroupItem,
	FooterPage
  },

  data() {
    return {
      show: false,
      showPayroll: false,
      showTimekeeping: false,
      observer: null,
      showLeftArrow: false,
      showRightArrow: false,
      centerIndex: 0,
      model: null,
      items: [
        { image: require("../assets/efficiency.png"), title: 'Efficiency', description: 'Description for Efficiency' },
        { image: require("../assets/data.png"), title: 'Data', description: 'Description for Data' },
        { image: require("../assets/payroll.png"), title: 'Payroll', description: 'Description for Payroll' },
        { image: require("../assets/emp_feedback.png"), title: 'Feedback', description: 'Description for Employee Feedback' },
        { image: require("../assets/compliance.png"), title: 'Compliance', description: 'Description for Compliance' },
        { image: require("../assets/emp_satisfaction.png"), title: 'Satisfaction', description: 'Description for Employee Satisfaction' },
      ],
    
    };
  },
};
</script>

<style>
.support-app {
  padding: 2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.support-app p {
  font-weight: 600;
  margin-bottom: 5px;
  font-size: 25px;
}

.support-app span {
  display: block;
  font-family: 'Poppins', 'san serif';
}

.app-badge {
  width: 150px; 
  height: auto;
  cursor: pointer;
  margin-right: 15px;
}

.app-icons {
  width: 600px; 
  height: auto;
}

.download-title{
  font-weight: 600;
  margin-bottom: 5px;
  font-size: 40px;
  margin-top: -30px;
}

.flip-container {
  perspective: 1000px;
  position: relative;
  width: 300px; 
  height: 300px; 
  
}

.flipper {
  transition: transform 0.6s;
  transform-style: preserve-3d;
  position: relative;
}

.front,
.back {
  backface-visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.back {
  transform: rotateY(180deg);
  text-align: center;
  background-color: #f9f9f9;
  display: none;
}

.description {
  width: 300px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Poppins', sans-serif;
}

.flip-container:hover .flipper {
  transform: rotateY(180deg);
}

.flip-container:hover .front {
  display: none;
}

.flip-container:hover .back {
  display: block;
}

.phrase {
  position: absolute;
  color: white;
  font-size: 14px;
  line-height: 1;
  padding: 5px;
  pointer-events: none; 
  font-family: 'Poppins', sans-serif;
}

.home { 
  justify-content: center;
  align-items: center;
}

.centered {
  text-align: center;
}

#home1 {
  padding: 0 15%;
  height: 100vh; 
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.homeImg {
  max-width: 100%; 
  height: auto; 
  object-fit: cover; 
  margin-top: -150px;
}

.homeImg2 {
  max-width: 40%; 
  height: auto; 
  object-fit: cover; 
  margin-top: -100px;
}

h1 {
  margin-bottom: 20px;
  font-size: 24px; 
  font-family: 'Poppins', sans-serif;
}

p {
  font-size: 18px;
  font-family: 'Poppins', sans-serif;
}

.v-btn {
  margin-top: 25px;  
  font-family: 'Poppins', sans-serif;
}

.hrisImg {
  margin-top: 15vh; 
  max-width: 100%; 
  height: auto; 
  object-fit: cover; 
}

.featureContent {
  display: flex;
  padding: 0 15%;
}

.readmoreHRIS {
  padding:0 15%;
  margin-top: 25px;
}

.pHRIS {
  margin-top: 22vh; 
  margin-left: 50px;
  font-size: 18px;
  text-align: justify; 
}

.tkImg {
  margin-top: 15vh; 
  max-width: 100%; 
  height: auto; 
  object-fit: cover; 
  margin-left: 50px;
}

.readHRIS {
  font-size: 25px;
  color: #27272a;
  margin-bottom: 100px;
  margin-top: 50px;
}

.graph {
  display: flex;
  margin-bottom: 10%;
}

.graphImg {
  width: 50%;
  margin-top: 2%;
  height: 50%;
}

.empImgs {
  width: 50%;
  margin-top: 2%;
  height: 50%;
}

.pGraph {
  display: flex;
  width: 50%;
  margin-right: 10%;
  text-align: justify;
}

.pEmp {
  width: 50%;
  margin-left: 10%;
  text-align: right;
}

.whyus {
  font-size: 25px;
}

#whyus {
  margin: 0 15%;
  overflow: hidden;
}

.whyus {
  margin-top: 2%;
}
#packages {
padding-top: 5%;
height: fit-content;
padding-bottom: 10%;
}

#features {
  padding-bottom: 5%;
}


.packHead {
  margin: 0 15%;
}




/* ANIMATIONS */
.animated {
  animation-duration: 3s;
  animation-fill-mode: both;
  opacity: 0;
}

.animate__animated.animate__backInRight {
  --animate-duration: 2s;
  --animate-delay: 0.9s;
}

.animate__animated.animate__backInLeft {
  --animate-duration: 2s;
  --animate-delay: 0.9s;

}
.workdeskOffers {
  display: flex;
  justify-content: flex-start;
  white-space: nowrap;
  position: relative;
}

.workdeskP {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.workdeskP h1 {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.packImg:hover {
  transform: scale(1.2);
}



/* additional */

@media (max-width: 768px) {
  .app-icons{
    max-width: 400px;
  }

  .support-app p{
    font-size: 20px;
  }

  .support-app span{
    font-size: 14px;
  }

  .download-title{
    font-size: 30px;
  }

  .app-badge{
    max-width: 100px;
  }

  .featureContent {
    flex-direction: column;
    align-items: center;
  }
  
  .pHRIS {
    margin-top: 5vh;
    margin-left: 0;
    text-align: center;
  }

  .hrisImg,
  .tkImg,
  .payrollImg {
    margin-top: 5vh;
    margin-left: 0;
    max-width: 100%;
    height: auto;
    object-fit: cover;
  }

  .readmoreHRIS {
    padding: 0;
    
  }

  .readHRIS {
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: center;
  }

  .graph,
  .graphImg,
  .empImgs,
  .pGraph,
  .pEmp {
    margin: 0;
    width: 100%;
    text-align: center;
  }

  .graphImg {
    width: 100%;
    height: auto;
  }

  .empImgs {
    margin-top: 2%;
    width: 100%;
    height: auto;
  }

  .whyus {
    margin-top: 5%;
  }
}
@media (max-width: 768px) {
  .hrisImg,
  .tkImg,
  .payrollImg {
    margin-top: 5vh;
    margin-left: 0;
    max-width: 50%;
    height: auto;
    object-fit: cover;
  }
}

@media (max-width: 768px) {
  .featureContent {
    flex-direction: column;
    align-items: center;
  }

  .pHRIS {
    margin-top: 5vh;
    margin-left: 0;
    text-align: center;
    font-size: 16px; 
  }

  .v-btn {
    margin-top: 15px;
    font-size: 14px; 
    padding: 10px 20px;
  }

  .hrisImg,
  .tkImg,
  .payrollImg {
    margin-top: 5vh;
    margin-left: 0;
    max-width: 50%;
    height: auto;
    object-fit: cover;
  }

  .readmoreHRIS {
    padding: 0;
  }

  .readHRIS {
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: center;
    font-size: 20px; 
  }

  .graph,
  .graphImg,
  .empImg,
  .pGraph,
  .pEmp {
    margin: 0;
    width: 100%;
    text-align: center;
  }

  .graphImg {
    width: 50%;
    height: 50%;
  }


 img, .empImg {
    max-width: 100%; 
    height: 50%; 
   
   
  }
  .whyus {
    margin-top: 5%;
  }
}

@media (max-width: 768px) {
  #home1 {
    padding: 0 10%; 
    height: auto; 
    padding-bottom: 10%;
  }

  .homeImg {
    margin-top: 15vh; 
    max-width: 90%; 
    height: auto; 
  }

  .homeImg2 {
    max-width: 40%; 
    margin-top: 100px;
    margin-bottom: -100px;
  }

  .centered {
    text-align: center; 
  }

  .animate__animated {
    animation-duration: 1s; 
  }

  .animate__backInRight,
  .animate__backInLeft {
    --animate-duration: 1s; 
  }

  h1 {
    font-size: 20px; 
    margin-top: 20px; 
  }

  p {
    font-size: 16px; 
  }

  .v-btn {
    margin-top: 20px; 
    font-size: 14px; 
    padding: 8px 16px; 
  }
}

@media (max-width: 768px) {
  .graph {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .graphImg {
    order: -1; /* Move the image to the top */
  }
  .homeImg2 {
    max-width: 50%; 
    margin-top: 80px;
    margin-bottom: -60px;
  }
}

@media (max-width: 468px) {
  .app-icons{
    margin-bottom: 20px;
    max-width: 250px;
  }

  .support-app p{
    font-size: 15px;
  }

  .support-app span{
    font-size: 12px;
  }

  .download-title{
    font-size: 20px;
    margin-top: 0px;
  }

  .app-badge{
    max-width: 80px;
  }
  .carousel-item {
    width: 100px;
     margin-right:5px; 
     height: 200px;
  }
  .workdeskOffers {
    margin: 0 1%;
  }
 
}
@media (max-width: 768px) {
  .carousel-item {
    width: 150px;
     margin-right:5px; 
     height: 200px;
  }

  .gateway {
    font-size: 10px;
  }

  .carouselTitle {
    font-size: xx-small;
    font-family: 'Poppins', sans-serif;
  }

  .workdeskOffers {
    margin: 0 3%;
  }


}


@media (min-width: 769px) {
  .carousel-item {
    width: 200px; margin-right:5px; height: 300px;
  }
  .carouselTitle {
    
    text-align: center;
    justify-self: center;
    align-self: center;
  }
}

@media (max-width: 768px) {
  .packHead {
  
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 10%;
    margin-top:10%;
  }
  .packHead .packPhrases {
    font-size: 20px; 
    text-align: justify;
  }
  .logo {
    width: 100px;
    height: 100px;
  }
  .flip-container {
   
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .pack {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .packMan {
    max-width: 40%;
    height: auto;
  }
  .flip-container {
    width: 100%;
  }
  .flipper {
    width: 300px;
    height: auto;
    margin: 0 auto;
  }
  .front, .back {
    width: 100%;
    height: auto;
  }
  .cloud {
    max-width: 100%;
    height: auto;
  }
}



@media (min-width: 769px) {
 
  .packHead .packPhrases {
    font-size: 35px; /* Adjust the font size as needed */
  }
}


@media (max-width: 768px) {
  .home,
  .features,
  .why-us {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  #contactUs {
    flex-direction: column;
    align-items: center;
    padding-top: 5%;
    padding-bottom: 5%;

  }
  .contact {
    margin-top: 20px;
    
  }

  .sendEmailImg {
    width: 90%; /* Adjust image size */
    height: auto;
    margin-top: 2%;
    display: none;
  }

  .v-text-field,
  .v-textarea {
    width: 100%;
  }

  .submit-button {
    width: 100%;
  }

  .contact h1 {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .contact{
    max-width: 100%;
  }
}

@media (min-width: 769px) {

.contact {
  width: 40%; 
  max-width: 400px; 
  margin: 40% auto; 
 
}
#contactUs {
  
  padding: 0 15%; 
  height: 100vh; 
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;

}

.contact {
  width: 40%; 
  max-width: 400px; 
  margin: 40% auto; 
}


.submit-button {
  width: 100%; 
}

.sendEmail {
  width: 50%;
  margin-top: 10%;
  
}



.sendEmailImg {
  max-width: 90%
}
}

</style>